import styled from '@emotion/styled';
import StoreGroupContent from 'views/QA/pages/StoreGroup/Content';
import Header from './Header';
import { useQaContext } from './Context';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  > header {
    flex: 0 0 auto;
    margin-bottom: 16px;
  }
  > div {
    flex: 1 0 0;
  }
`;

function StoreGroup() {
  const { platform, region } = useQaContext();

  return (
    <Container>
      <Header />
      <StoreGroupContent key={`${platform}@${region}`} />
    </Container>
  );
}

export default StoreGroup;
